import { Carrier } from '@/data/mobile/carrier';
import { SimType } from '@/data/mobile/simType';
import { CarrierId } from '@/@types/carrierId';

// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

interface PlanProperties {
  name: string;
  charge: number;
  m2m?: boolean;
  office_user_monthly_charge_free?: boolean;
  campaign_application_fee: CampaignInfo;
  campaign_sim_comission_fee: CampaignInfo;
}

interface CampaignInfo {
  name: string | null;
  amount: number | null;
}

export class Plan {
  public id: string;
  public planName: string;
  public charge: number;
  public isM2m: boolean;
  public simType: SimType;
  public carriers: Carrier[];
  public isOfficeUserMonthlyChargeFree: boolean;
  public campaignApplicationFeeAmounts: { docomo: number; au: number } = {
    docomo: 0,
    au: 0,
  };
  public campaignSimComissionFeeAmounts: { docomo: number; au: number } = {
    docomo: 0,
    au: 0,
  };

  // tslint:disable-next-line:max-line-length
  constructor(
    id: string,
    simType: SimType,
    carrier: Carrier,
    {
      name = '',
      charge = 0,
      m2m = false,
      office_user_monthly_charge_free = false,
      campaign_application_fee,
      campaign_sim_comission_fee,
    }: PlanProperties
  ) {
    this.id = id;
    this.planName = name;
    this.charge = charge;
    this.isM2m = m2m;
    this.simType = simType;
    this.carriers = [carrier];
    this.isOfficeUserMonthlyChargeFree =
      office_user_monthly_charge_free == undefined
        ? false
        : office_user_monthly_charge_free;
    this.initializeCampaignApplicationFeeAmounts(
      carrier.id,
      campaign_application_fee
    );
    this.initializeCampaignSimComissionFeeAmounts(
      carrier.id,
      campaign_sim_comission_fee
    );
  }

  public updateProperties(
    carrier: Carrier,
    campaign_application_fee: CampaignInfo,
    campaign_sim_comission_fee: CampaignInfo
  ) {
    this.carriers = _.concat(this.carriers, carrier);
    this.initializeCampaignApplicationFeeAmounts(
      carrier.id,
      campaign_application_fee
    );
    this.initializeCampaignSimComissionFeeAmounts(
      carrier.id,
      campaign_sim_comission_fee
    );
  }

  private initializeCampaignApplicationFeeAmounts(
    carrier: CarrierId,
    campaign_application_fee: CampaignInfo
  ) {
    const fee_amount =
      campaign_application_fee.amount == null
        ? 0
        : campaign_application_fee.amount;
    this.campaignApplicationFeeAmounts[carrier] = fee_amount;
  }

  private initializeCampaignSimComissionFeeAmounts(
    carrier: CarrierId,
    campaign_sim_comission_fee: CampaignInfo
  ) {
    const fee_amount =
      campaign_sim_comission_fee.amount == null
        ? 0
        : campaign_sim_comission_fee.amount;
    this.campaignSimComissionFeeAmounts[carrier] = fee_amount;
  }

  public name() {
    return `${this.planName}${this.isM2m ? '【M2M専用】' : ''}`;
  }

  public canUse(carrier: string): boolean {
    const list = this.carriers.map(c => {
      return c.id;
    });
    return _.includes(list, carrier);
  }

  public initCost(carrier: CarrierId): number {
    const c = this.carriers.find(item => {
      return item.id == carrier;
    });
    let total = 0;
    if (c !== undefined) {
      const regular =
        (c.applicationFee as number) + (c.simComissionFee as number);
      const discountAmount =
        this.campaignApplicationFeeAmounts[carrier] +
        this.campaignSimComissionFeeAmounts[carrier];
      total = regular - discountAmount;
    }
    return total;
  }
}
